import Input from '../../../../../common/components/Input';
import React, { Fragment, useEffect, useMemo, useRef } from 'react';
import Svg from '../../../../../common/components/Svg';
import cn from 'classnames';
import { debounce } from 'lodash';
import { changeSearchValue } from '../../../../../chat/modules/load-messages';
import { connect } from 'react-redux';

const ChatSearch = ({
  icon = 'icon-search',
  onChange = () => {},
  open,
  setOpen = () => {},
  changeSearchValue,
  ...rest
}) => {
  const debouncedOnChange = useMemo(() => debounce(changeSearchValue, 1000), [onChange]);
  const handleOnChange = e => {
    const value = { ...e }.target.value;
    debouncedOnChange(value);
  };
  const inputRef = useRef();

  useEffect(
    () => {
      inputRef.current.focus();
      return () => {
        debouncedOnChange('');
      };
    },
    [open],
  );

  return (
    <div className="chat_search">
      <Svg
        onClick={() => {
          setOpen(prev => !prev);
        }}
        className="chat_search_icon"
        icon={icon}
      />
      <Input
        className={cn('chat_search_input', { open })}
        ref={inputRef}
        {...rest}
        placeholder="Search"
        onChange={handleOnChange}
      />
    </div>
  );
};

export default connect(
  undefined,
  { changeSearchValue },
)(ChatSearch);



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/components/chat/shared/components/ChatSearch.js